import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getData, postData } from "../Commonfunction/CommonFunction";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { Field, FieldArray, Form, Formik } from "formik";
import { CiRead } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdLibraryAdd } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import '../../assets/style/MultiFIle.css'

export default function MultiFIle({ custData, onClose = false, closeModal }) {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const userType = localStorage.getItem("user_type");
  const [loading, setLoading] = useState(false);
  const [singleData, setSingleData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [filePreviews, setFilePreviews] = useState([]);
  
  const { id } = useParams();
  
  const ALLOWED_FILE_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/xml",
    "application/json",
    "text/csv",
  ];

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

  useEffect(() => {
    // Uncomment when needed
    // getDataFile();
  }, []);

  const getDataFile = async () => {
    try {
      setLoading(true);
      const result = await getData(`/api/get-employee/${id}`);
      if (result.success) {
        // setIsEdit(true);
        // setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const request_url = isEdit
        ? `/api/updateTaxreturn/${id}`
        : "/api/createTaxreturn";
      const postDataResult = await postData(request_url, values);
      if (postDataResult.success) {
        toast.success(postDataResult.message);
      } else {
        toast.error(postDataResult.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form");
    } finally {
      setLoading(false);
    }
  };

  const handleFile = async (values) => {
    try {
      const request_url = isEdit
        ? `/api/updateTaxreturn/${id}`
        : "/api/createTaxreturn";
      const postDataResult = await handleSubmitFile(values, request_url);
      if (postDataResult?.success) {
        toast.success(postDataResult?.message);
      } else {
        toast.error(postDataResult?.message);
      }
    } catch (error) {
      console.error("Error handling file:", error);
      toast.error("Failed to process file");
    }
  };

  const cpc_db_connect = localStorage.getItem("cpc_db");
  
  const handleSubmitFile = (values, request_url) => {
    return axios
      .post(request_url, values, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "X-CPC-Connect": cpc_db_connect,
        },
      })
      .then(
        (response) => {
          if (response.data.success) {
            toast.success(response.data.message);
            return response.data;
          } else {
            toast.error(response.data.message);
            return response.data;
          }
        },
        (error) => {
          if (error.response?.status === 401) {
            toast.error(error.response.data.message);
          }
          return error;
        }
      );
  };

  const validationSchema = Yup.object().shape({
    document_info: Yup.array().of(
      Yup.object().shape({
        document_name: Yup.string().required("Document name is required"),
        employee_documents: Yup.string().required("Document is required"),
      })
    ),
  });

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (event, index, setFieldValue) => {
    const file = event.currentTarget.files[0];

    if (!file) {
      toast.info("No file selected");
      return;
    }

    // Check file type
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      toast.error("Invalid file type. Allowed types: PDF, DOC, DOCX, XLS, XLSX, XML, JSON, CSV");
      return;
    }

    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size exceeds 5 MB limit");
      return;
    }

    // If valid, process the file
    setFieldValue(`document_info.${index}.file`, file);

    try {
      const base64 = await fileToBase64(file);
      setFieldValue(`document_info.${index}.employee_documents`, base64);

      // Update previews
      setFilePreviews((prevPreviews) => {
        const newPreviews = [...prevPreviews];
        newPreviews[index] = { name: file.name, base64 };
        return newPreviews;
      });
    } catch (error) {
      toast.error("Failed to process file. Please try again");
      console.error("File processing error:", error);
    }
  };

  const getMonthNumber = (monthName) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];

    const monthIndex = months.findIndex(
      (month) => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex === -1) {
      throw new Error("Invalid month name");
    }

    return String(monthIndex + 1).padStart(2, "0");
  };

  return (
    <div className="document-upload-container">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      
      <Formik
        enableReinitialize
        initialValues={{
          document_info: isEdit
            ? singleData?.documents
            : [{ document_name: "", employee_documents: "" }],
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const documentInfo = values?.document_info?.map((item) => ({
            document_name: item?.document_name,
            taxreturn_documents: item?.employee_documents,
          }));

          const monthNumber = getMonthNumber(custData?.month);

          const updateValue = {
            document_info: documentInfo,
            year: custData?.year,
            month: monthNumber,
            client_id: id,
            client_name: custData?.company_name,
            fileno: custData?.customer_file_no,
            user_name: `${username}-${userType}`,
          };
          
          handleSubmit(updateValue);
        }}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="document-form">
            <div className="card">
              
              
              <div className="card-body">
                <FieldArray name="document_info">
                  {({ insert, remove, push }) => (
                    <div className="document-table-container">
                      <table className="document-table">
                        <thead>
                          <tr>
                            <th>Document Name <span className="required">*</span></th>
                            <th>Upload Document <span className="required">*</span></th>
                            <th>Preview</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.document_info?.length > 0 &&
                            values.document_info.map((doc, index) => (
                              <tr key={index} className="document-row">
                                <td>
                                  <div className="form-group">
                                    <Field
                                      className={`form-control ${
                                        errors.document_info?.[index]?.document_name &&
                                        touched.document_info?.[index]?.document_name
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name={`document_info.${index}.document_name`}
                                      type="text"
                                      placeholder="Enter document name"
                                    />
                                    {errors.document_info?.[index]?.document_name &&
                                      touched.document_info?.[index]?.document_name && (
                                        <div className="error-message">
                                          {errors.document_info[index].document_name}
                                        </div>
                                      )}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group file-upload-container">
                                    <div className="file-upload-wrapper">
                                      <input
                                        type="file"
                                        id={`file-upload-${index}`}
                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.xml,.json,.csv"
                                        onChange={(event) =>
                                          handleFileChange(event, index, setFieldValue)
                                        }
                                        className="file-upload-input"
                                      />
                                      <label 
                                        htmlFor={`file-upload-${index}`}
                                        className="file-upload-label"
                                      >
                                        {filePreviews[index]?.name || "Choose File"}
                                      </label>
                                    </div>
                                    {errors.document_info?.[index]?.employee_documents &&
                                      touched.document_info?.[index]?.employee_documents && (
                                        <div className="error-message">
                                          {errors.document_info[index].employee_documents}
                                        </div>
                                      )}
                                  </div>
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className={`btn btn-preview ${
                                      !values.document_info[index].employee_documents
                                        ? "btn-disabled"
                                        : ""
                                    }`}
                                    disabled={!values.document_info[index].employee_documents}
                                    onClick={() => {
                                      const base64 = values.document_info[index].employee_documents;
                                      const fileName =
                                        values.document_info[index].file?.name || "file";
                                      if (base64) {
                                        const link = document.createElement("a");
                                        link.href = base64;
                                        link.download = fileName;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                      } else {
                                        toast.info("No file uploaded");
                                      }
                                    }}
                                  >
                                    <CiRead className="icon" /> View
                                  </button>
                                </td>
                                <td className="text-center action-buttons">
                                  {index !== 0 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => remove(index)}
                                    >
                                      <RiDeleteBin6Line className="icon" />
                                    </button>
                                  )}
                                  {index === values.document_info.length - 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-add"
                                      onClick={() =>
                                        push({
                                          document_name: "",
                                          employee_documents: "",
                                        })
                                      }
                                    >
                                      <MdLibraryAdd className="icon" />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </FieldArray>
              </div>
              
              <div className="card-footer">
                <div className="button-group">
                  {onClose && (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => closeModal(false)}
                    >
                      Cancel
                    </button>
                  )}
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    <FaSave className="icon" /> 
                    {isEdit ? "Update" : "Save"} Documents
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      
    
    </div>
  );
}